/**
 * Why there is no map, said on the canvas.
 *
 * Every board that mounts a vendored renderer has the same three-line problem:
 * the geometry is a client-side asset (M5-D11) and it can be missing, wrong for
 * this scenario, or short of a region the wire declares. An empty canvas answers
 * none of those, and a console that looks like it is working while drawing
 * nothing is the failure this component exists to prevent.
 *
 * Title names the condition; the one line under it says what is missing. Nothing
 * explains the mechanism (`.claude/CLAUDE.md`).
 */
export function MapNotice(props: {
  readonly title: string;
  readonly detail?: string;
  readonly testId: string;
}): JSX.Element {
  return (
    <div
      data-testid={props.testId}
      data-mat="ticks"
      style={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: 24,
        background: 'var(--canvas)',
        textAlign: 'center',
      }}
    >
      <span
        style={{
          fontFamily: 'var(--font-data)',
          fontSize: 11,
          letterSpacing: '.14em',
          textTransform: 'uppercase',
          color: 'var(--text-muted)',
        }}
      >
        {props.title}
      </span>
      {props.detail !== undefined && (
        <span
          data-testid={props.testId + '-detail'}
          style={{
            maxWidth: 380,
            fontFamily: 'var(--font-data)',
            fontSize: 11,
            letterSpacing: '.1em',
            textTransform: 'uppercase',
            // The only line on the screen saying what is wrong with the map pack.
            color: 'var(--text-dim)',
          }}
        >
          {props.detail}
        </span>
      )}
    </div>
  );
}
